import { useDispatch, useSelector } from "react-redux";
import { useState, useRef, useEffect } from "react";
import Styles from "./Heading.module.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SouthIcon from "@mui/icons-material/South";
import NorthIcon from "@mui/icons-material/North";
import { Slider } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ReactDOM from "react-dom";
import TimeInput from "../../../commons/Inputs/TimeInputBailateral/TimeInput";
import { getAllCreditRating } from "../../../Services/ApiCalling/PublicApi";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../../helpers/dateFormat";
import {
  fetchSelfCapacity,
  setActiveListingId,
} from "../../../Redux/Slices/CapacitySlice";

const AvailableHeader = ({
  energyRateSortDir,
  quantitySortDir,
  setEnergyRateSortDir,
  setQuantitySortDir,
  activeFilter,
  setActiveFilter,
  filterState,
  setFilterState,
  showBackbtn,
  stateListingCount,
}) => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [ratingsList, setRatingsList] = useState([]);
  const [errors, setErrors] = useState({});
  const [localFilterState, setLocalFilterState] = useState(filterState);
  const navigation = useNavigate();
  const dispatch = useDispatch();

  async function getCreditRatinga() {
    try {
      const ratings = await getAllCreditRating();
      if (ratings?.data?.code === 200) {
        setRatingsList(ratings?.data?.data || []);
      }
    } catch (error) {
      console.error("Error fetching credit ratings:", error);
    }
  }

  useEffect(() => {
    getCreditRatinga();
  }, []);

  useEffect(() => {
    if (isFilterOpen) {
      setLocalFilterState(filterState);
    }
  }, [isFilterOpen, filterState]);

  const validateFields = (state) => {
    const newErrors = {};

    // Quantity validation
    if (state.quantity[0] > state.quantity[1]) {
      newErrors.quantity = "Min quantity cannot be greater than max quantity";
    }

    // Energy Rate validation
    if (state.energyRate[0] > state.energyRate[1]) {
      newErrors.energyRate = "Min rate cannot be greater than max rate";
    }

    // Dates validation
    if (state.startDate && state.endDate && state.startDate > state.endDate) {
      newErrors.startDate = "Start date cannot be after end date";
      newErrors.endDate = "End date cannot be before start date";
    }

    // Time validation
    if (state.startTime && state.endTime && state.startTime >= state.endTime) {
      newErrors.startTime = "Start time must be before end time";
      newErrors.endTime = "End time must be after start time";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const counterList = useSelector((state) => state?.CapacitySlice?.counterList);

  const mainScreenMatchData = useSelector(
    (state) => state?.CapacitySlice?.mainScreenActiveConnection
  );
  const user = useSelector(
    (state) => state?.persistedReducer?.userType
  )?.toLowerCase();

  let activeMainId = useSelector(
    (state) => state?.CapacitySlice?.activeMain?.id
  );

  const params = new URLSearchParams(window.location.search);
  const id = Number(params.get("id"));

  useEffect(() => {
    if (!activeMainId) {
      dispatch(setActiveListingId(id));
    }
  }, [activeMainId, dispatch, id]);

  const finalActiveId = activeMainId || id;

  const list = useSelector((state) => state?.CapacitySlice?.list);

  useEffect(() => {
    if (!list) {
      dispatch(fetchSelfCapacity({ user }));
    }
  }, [dispatch, list, user]);

  const finFinal = list?.find((ele) => ele?.id === finalActiveId);

  const filterOptions = [
    { key: "ALL", label: "All" },
    // { key: "FINALIZED", label: "Finalized" },
    { key: "ACCEPTED", label: "Accepted" },
    { key: "RECEIVED/PLACED", label: "Received/Placed" },
    // { key: "INTRADAY", label: "Intraday" },
    // { key: "NEXT_DAY", label: "Next Day" },
    // { key: "UPTO_7_DAYS", label: "Upto 7 days" },
    // { key: "GREATER_THAN_7_DAYS", label: "Greater than 7 days" },
  ];

  const handleFilterClick = (filter) => {
    setActiveFilter(filter);
  };

  const handleApplyFilter = () => {
    if (validateFields(localFilterState)) {
      setFilterState(localFilterState); // Update main state only on Apply
      setIsFilterOpen(false);
    }
  };
  useEffect(() => {
    if (!isFilterOpen) {
      setErrors({}); // Reset errors when modal closes
      return;
    }

    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setIsFilterOpen(false);
        setErrors({}); // Reset errors when modal closes
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isFilterOpen]);

  const handleResetFilter = () => {
    setLocalFilterState({
      quantity: [0, 10000],
      energyRate: [0, 200],
      energyType: "",
      creditRating: "",
      startDate: "",
      endDate: "",
      startTime: "",
      endTime: "",
    });
  };

  const filterRef = useRef(null);

  useEffect(() => {
    if (!isFilterOpen) return;

    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setIsFilterOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isFilterOpen]);

  // Add this helper to compute number of applied filters
  const defaultFilter = {
    quantity: [0, 10000],
    energyRate: [0, 200],
    energyType: "",
    creditRating: "",
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
  };

  const getAppliedFiltersCount = (fs = filterState) => {
    if (!fs) return 0;
    let count = 0;
    if (
      !(
        fs.quantity?.[0] === defaultFilter.quantity[0] &&
        fs.quantity?.[1] === defaultFilter.quantity[1]
      )
    )
      count++;
    if (
      !(
        fs.energyRate?.[0] === defaultFilter.energyRate[0] &&
        fs.energyRate?.[1] === defaultFilter.energyRate[1]
      )
    )
      count++;
    if (fs.energyType) count++;
    if (fs.creditRating) count++;
    if (fs.startDate) count++;
    if (fs.endDate) count++;
    if (fs.startTime) count++;
    if (fs.endTime) count++;
    return count;
  };

  const appliedCount = getAppliedFiltersCount(filterState);

  const isContractStatus = ["TERMS_ACCEPTED", "ONGOING", "CLOSED"].includes(
    finFinal?.status
  );
  const displayLabel = isContractStatus
    ? "Contracts :"
    : "Available Listings :";

  let listingCount = counterList?.length || 0;
  if (isContractStatus) {
    listingCount = mainScreenMatchData?.length || 0;
  } else if (finFinal?.status === "TERMS_INITIATED") {
    if (
      user === "consumer" &&
      mainScreenMatchData?.some((obj) => obj.initiatorType === "consumer")
    ) {
      listingCount =
        (mainScreenMatchData?.length || 0) +
        (counterList?.filter((e) => e.status === "APPROVED").length || 0);
    } else {
      listingCount = counterList?.length || 0;
    }
  }

  return (
    <>
      <div className={`display_flex_row ${Styles.selfHeaderContainer}`}>
        <div
          className={`display_flex_row_center ${Styles.selfHeaderAvailable}`}
        >
          {showBackbtn && (
            <>
              {" "}
              <div
                onClick={() => navigation("/dashboard")}
                style={{ marginRight: "10px" }}
                className={`display_flex_row_gap_4 ${Styles.backButton}`}
              >
                <ChevronLeftIcon style={{ fontSize: "16px" }} />
                <span style={{ fontSize: "12px" }}>Back</span>
              </div>
              <div>
                <p style={{ fontSize: "15px" }}>{finFinal?.name} - </p>
              </div>
            </>
          )}
          {displayLabel} <span>{stateListingCount}</span>
        </div>
        <div
          className={` display_flex_row_center ${Styles.availableListingSortFilter}`}
        >
          <div
            className={` display_flex_row_center ${Styles.availableListingSortFilter}`}
          >
            <div className={Styles.sortContainer}>
              <span className={Styles.sortHead}>Sort</span>
              <button
                className={
                  energyRateSortDir === "asc" ? Styles.activeSortBtn : ""
                }
                onClick={() => {
                  setEnergyRateSortDir(
                    energyRateSortDir === "asc" ? "desc" : "asc"
                  );
                  setQuantitySortDir("");
                }}
              >
                Energy Rate{" "}
                {energyRateSortDir === "asc" ? (
                  <SouthIcon style={{ fontSize: "12px" }} />
                ) : (
                  <NorthIcon style={{ fontSize: "12px" }} />
                )}
              </button>
              <button
                className={
                  quantitySortDir === "asc" ? Styles.activeSortBtn : ""
                }
                onClick={() => {
                  setQuantitySortDir(
                    quantitySortDir === "asc" ? "desc" : "asc"
                  );
                  setEnergyRateSortDir("");
                }}
              >
                Quantity{" "}
                {quantitySortDir === "asc" ? (
                  <SouthIcon style={{ fontSize: "12px" }} />
                ) : (
                  <NorthIcon style={{ fontSize: "12px" }} />
                )}
              </button>
            </div>
          </div>
          <div
            className={`display_flex_row_center activeButton_type_2 ${Styles.filterButton}`}
            onClick={() => setIsFilterOpen(!isFilterOpen)}
            onMouseDown={isFilterOpen ? (e) => e.stopPropagation() : undefined}
            style={{ position: "relative" }} // ensure badge positions correctly
          >
            <span>Filter</span>
            <ExpandMoreIcon
              style={{
                fontSize: "16px",
                transform: isFilterOpen ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.3s ease",
              }}
            />
            {appliedCount > 0 && (
              <div className={Styles.filterBadge}>{appliedCount}</div>
            )}
          </div>
        </div>
      </div>

      {isFilterOpen &&
        ReactDOM.createPortal(
          <div ref={filterRef} className={Styles.filterDropdown}>
            <div className={Styles.filterHeader}>
              <span>Filters</span>
            </div>
            <div className={Styles.filterContent}>
              <div>
                <div
                  style={{
                    background: "white",
                    padding: "20px",
                    borderRadius: "12px",
                  }}
                  className={Styles.filterRow}
                >
                  {/* Quantity */}
                  <div className={Styles.filterField}>
                    <label>Quantity (MW)</label>
                    <div className={Styles.rangeSlider}>
                      <div className={Styles.rangeValues}>
                        <span>{filterState.quantity[0]}</span>
                        <span>{filterState.quantity[1]}</span>
                      </div>
                      <Slider
                        value={localFilterState.quantity}
                        onChange={(e, newValue) =>
                          setLocalFilterState({
                            ...localFilterState,
                            quantity: newValue,
                          })
                        }
                        min={0}
                        max={10000}
                        valueLabelDisplay="auto"
                        sx={{
                          color: "var(--primary-color-text)",
                          "& .MuiSlider-thumb": {
                            width: 18,
                            height: 18,
                            fontSize: "12px",
                            backgroundColor: "var(--primary-color-text)",
                            border: "3px solid white",
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                            "&:hover, &.Mui-focusVisible": {
                              boxShadow: "0 0 0 8px rgba(255, 107, 53, 0.16)",
                            },
                          },
                          "& .MuiSlider-track": {
                            height: 6,
                            border: "none",
                          },
                          "& .MuiSlider-rail": {
                            height: 6,
                            opacity: 0.3,
                            backgroundColor: "#ddd",
                          },
                        }}
                      />
                    </div>
                    {errors.quantity && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.quantity}
                      </div>
                    )}
                  </div>

                  {/* Energy Rate */}
                  <div className={Styles.filterField}>
                    <label>Energy Rate (kWh)</label>
                    <div className={Styles.rangeSlider}>
                      <div className={Styles.rangeValues}>
                        <span>{filterState.energyRate[0]}</span>
                        <span>{filterState.energyRate[1]}</span>
                      </div>
                      <Slider
                        value={localFilterState.energyRate}
                        onChange={(e, newValue) =>
                          setLocalFilterState({
                            ...localFilterState,
                            energyRate: newValue,
                          })
                        }
                        min={0}
                        max={200}
                        valueLabelDisplay="auto"
                        sx={{
                          color: "var(--primary-color-text)",
                          "& .MuiSlider-thumb": {
                            width: 18,
                            height: 18,
                            backgroundColor: "var(--primary-color-text)",
                            border: "3px solid white",
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                            "&:hover, &.Mui-focusVisible": {
                              boxShadow: "0 0 0 8px rgba(255, 107, 53, 0.16)",
                            },
                          },
                          "& .MuiSlider-track": {
                            height: 6,
                            border: "none",
                          },
                          "& .MuiSlider-rail": {
                            height: 6,
                            opacity: 0.3,
                            backgroundColor: "#ddd",
                          },
                        }}
                      />
                    </div>
                    {errors.energyRate && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.energyRate}
                      </div>
                    )}
                  </div>
                  {/* 
                  <div className={Styles.filterField}>
                    <label>Energy Type</label>
                    <select
                      value={filterState.energyType}
                      onChange={(e) =>
                        setFilterState({
                          ...filterState,
                          energyType: e.target.value,
                        })
                      }
                    >
                      <option value="">Select</option>
                      <option value="solar">Solar</option>
                      <option value="wind">Wind</option>
                      <option value="hydro">Hydro</option>
                    </select>
                  </div> */}

                  {/* Credit Rating */}
                  <div className={Styles.filterField}>
                    <label>Credit Rating</label>
                    <select
                      value={localFilterState.creditRating}
                      onChange={(e) =>
                        setLocalFilterState({
                          ...localFilterState,
                          creditRating: e.target.value,
                        })
                      }
                    >
                      <option value="">Select</option>
                      {ratingsList.map((rating) => (
                        <option key={rating.id} value={rating.rating}>
                          {rating.rating}
                        </option>
                      ))}
                    </select>
                    {errors.creditRating && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.creditRating}
                      </div>
                    )}
                  </div>
                </div>

                <div
                  style={{
                    background: "white",
                    padding: "20px",
                    borderRadius: "12px",
                    marginTop: "15px",
                  }}
                  className={Styles.filterRow}
                >
                  {/* Start Date */}
                  <div className={Styles.filterField}>
                    <label>Start Date</label>
                    <input
                      type="date"
                      value={localFilterState.startDate}
                      onChange={(e) =>
                        setLocalFilterState({
                          ...localFilterState,
                          startDate: e.target.value,
                        })
                      }
                    />
                    {errors.startDate && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.startDate}
                      </div>
                    )}
                  </div>

                  {/* End Date */}
                  <div className={Styles.filterField}>
                    <label>End Date</label>
                    <input
                      type="date"
                      value={localFilterState.endDate}
                      onChange={(e) =>
                        setLocalFilterState({
                          ...localFilterState,
                          endDate: e.target.value,
                        })
                      }
                    />
                    {errors.endDate && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.endDate}
                      </div>
                    )}
                  </div>

                  {/* Start Time */}
                  <div className={Styles.filterField}>
                    <TimeInput
                      noTooltip={true}
                      isRtc={false}
                      type={"startTime"}
                      heading={"Start Time"}
                      value={localFilterState.startTime}
                      onChange={(value) =>
                        setLocalFilterState({
                          ...localFilterState,
                          startTime: value,
                        })
                      }
                      startDate={localFilterState.startDate}
                      minutesStep={15}
                      height={35}
                    />
                    {errors.startTime && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.startTime}
                      </div>
                    )}
                  </div>

                  {/* End Time */}
                  <div className={Styles.filterField}>
                    <TimeInput
                      isRtc={false}
                      type={"endTime"}
                      heading={"End Time"}
                      value={localFilterState.endTime}
                      onChange={(value) =>
                        setLocalFilterState({
                          ...localFilterState,
                          endTime: value,
                        })
                      }
                      startDate={localFilterState.endDate}
                      minutesStep={15}
                      height={35}
                    />
                    {errors.endTime && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.endTime}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className={Styles.filterActions}>
                <button
                  className={Styles.resetButton}
                  onClick={handleResetFilter}
                >
                  Reset
                </button>
                <button
                  className={Styles.applyButton}
                  onClick={handleApplyFilter}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}

      {showBackbtn && (
        <div className={Styles.headerContainer}>
          <div>
            {" "}
            <span className={Styles.Label}>
              Energy Type <div> {finFinal?.energyFuelType}</div>
            </span>
          </div>
          <div>
            <div className={Styles.Label}>
              {user === "consumer" ? "Point of Drawal" : "Point of Injec."}{" "}
              <div>{finFinal?.isInterstate ? "Interstate" : "Intra-state"}</div>
            </div>
          </div>
          {/* <div>
            {" "}
            <span className={Styles.Label}>
              EMD <div> {finFinal?.emd} (₹/kWh)</div>
            </span>
          </div>
          <div>
            {" "}
            <span className={Styles.Label}>
              Initial Margin <div>{finFinal?.initialMargin}%</div>
            </span>
          </div> */}

          <div>
            {" "}
            <span className={Styles.Label}>
              Product Type{" "}
              <div>
                {(() => {
                  const lt = finFinal?.listingType;
                  return lt === "INTRA_DAY"
                    ? "Intraday"
                    : lt === "NEXT_DAY"
                    ? "Next Day"
                    : lt === "UPTO_SEVEN_DAYS"
                    ? "Next 7 Days"
                    : lt === "GREATER_THAN_SEVEN_DAYS"
                    ? "Greater than 7 Days"
                    : "-";
                })()}
              </div>
            </span>
          </div>
          <div>
            {" "}
            <span className={Styles.Label}>
              Listing Expiry Date & Time{" "}
              <div>
                {formatDate(finFinal?.listingExpDate)} -{" "}
                {finFinal?.listingExpTime}
              </div>
            </span>
          </div>

          <div className={Styles.stepperContainer}>
            <div className={Styles.stepperHeader}>
              <span className={Styles.stepperStepText}>
                {finFinal?.status === "ONGOING"
                  ? "Step 3 of 3"
                  : finFinal?.status === "TERMS_ACCEPTED"
                  ? "Step 2 of 3"
                  : "Step 1 of 3"}
              </span>
              <span className={Styles.stepperTitle}>
                {finFinal?.status === "ONGOING"
                  ? "Scheduling and Close"
                  : finFinal?.status === "TERMS_ACCEPTED"
                  ? "Documentation"
                  : "Finalizing Terms & Conditions"}
              </span>
            </div>

            <div className={Styles.statusStepper}>
              {[
                {
                  completed: [
                    "TERMS_ACCEPTED",
                    "AGGREMENT_APPROVED",
                    "ONGOING",
                  ].includes(finFinal?.status),
                  active: [
                    "TERMS_INITIATED",
                    "APPROVED",
                    "TERMS_ACCEPTED",
                    "AGGREMENT_APPROVED",
                    "RECEIVED",
                    "PLACED",
                    "ONGOING",
                  ].includes(finFinal?.status),
                },
                {
                  completed: ["AGGREMENT_APPROVED", "ONGOING"].includes(
                    finFinal?.status
                  ),
                  active: [
                    "TERMS_ACCEPTED",
                    "AGGREMENT_APPROVED",
                    "ONGOING",
                  ].includes(finFinal?.status),
                },
                {
                  completed: false,
                  active: finFinal?.status === "ONGOING",
                },
              ].map((step, idx) => (
                <span
                  key={idx}
                  className={`${Styles.stepCircle} ${
                    step.completed
                      ? Styles.completed
                      : step.active
                      ? Styles.active
                      : Styles.inactive
                  }`}
                >
                  {step.completed ? (
                    <span className={Styles.checkIcon}>&#10003;</span>
                  ) : (
                    <span
                      className={
                        step.active ? Styles.activeDot : Styles.inactiveDot
                      }
                    ></span>
                  )}
                </span>
              ))}
            </div>
          </div>
        </div>
      )}

      {(finFinal?.status === "ACTIVE" ||
        finFinal?.status === "RECEIVED" ||
        finFinal?.status === "PLACED" ||
        finFinal?.status === "TERMS_INITIATED" ||
        finFinal?.status === "APPROVED") && (
        <div className={Styles.sortSection}>
          {filterOptions.map((filter) => (
            <div
              key={filter.key}
              className={`${Styles.filterButton} ${
                activeFilter === filter.key ? Styles.activeFilter : ""
              }`}
              onClick={() => handleFilterClick(filter.key)}
            >
              {filter.label}
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default AvailableHeader;
